import React from 'react';

import { Autocomplete, TableCell, TableRow, TextField } from '@mui/material';

import { EGS_GUEST_TYPE_LABELS } from '../tabs/egs/fields';
import type { EgsRoomRow } from '../tabs/egs/previousEgs';

export type EgsRoomsChange = (key: string, rooms: Array<string>) => void;

type CopyEgsRoomsRowProps = {
  onRoomsChange: EgsRoomsChange;
  roomNames: Array<string>;
  row: EgsRoomRow;
  rooms: Array<string>;
};

export default function CopyEgsRoomsRow({ onRoomsChange, roomNames, row, rooms }: CopyEgsRoomsRowProps) {
  function handleChange(_event: React.SyntheticEvent, value: Array<string>) {
    onRoomsChange(row.key, value);
  }

  return (
    <TableRow>
      <TableCell>{row.name || 'No name'}</TableCell>
      <TableCell>{row.guestTypes.map((guestType) => EGS_GUEST_TYPE_LABELS[guestType]).join(', ')}</TableCell>
      <TableCell sx={{ minWidth: 280 }}>
        <Autocomplete
          disableCloseOnSelect
          multiple
          onChange={handleChange}
          options={roomNames}
          renderInput={(params) => (
            <TextField
              {...params}
              error={!rooms.length}
              helperText={rooms.length ? undefined : 'Pick at least one room'}
              placeholder={rooms.length ? undefined : 'Pick rooms'}
            />
          )}
          size="small"
          value={rooms}
        />
      </TableCell>
    </TableRow>
  );
}
